import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { ItemSelectorModule } from '@galaxy/inventory-ui';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { BillingUiModule } from '@vendasta/billing-ui';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { VaPricingModule } from '@vendasta/store';
import { VaBadgeModule, VaIconModule } from '@vendasta/uikit';
import { Filter2TableModule } from '@vendasta/va-filter2-table';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../shared/constants';
import { AppSelectorComponent } from './app-selector/app-selector.component';
import { AppNameCellComponent } from './app-selector/cells/app-name-cell.component';
import { AppRevenueCellComponent } from './app-selector/cells/app-revenue-cell.component';
import { AppRevenueHeaderCellComponent } from './app-selector/cells/app-revenue-header-cell.component';
import { AppSelectorCustomComponentDirective } from './app-selector/cells/app-selector-custom.component';
import { AppWholesaleHeaderCellComponent } from './app-selector/cells/app-wholesale-header-cell.component';
import { ItemSelectorAdapterComponent } from './item-selector-adapter/item-selector-adapter.component';
import { ItemSelectorAdapterService } from './item-selector-adapter/item-selector-adapter.service';
import { SalesOrderLineItemSelectorComponent } from './sales-order-line-item-selector.component';

@NgModule({
  imports: [
    CommonModule,
    Filter2TableModule,
    MatTabsModule,
    VaIconModule,
    VaPricingModule,
    VaBadgeModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatSelectModule,
    BillingUiModule,
    GalaxyBadgeModule,
    ItemSelectorModule,
  ],
  declarations: [
    SalesOrderLineItemSelectorComponent,
    AppSelectorComponent,
    ItemSelectorAdapterComponent,
    AppNameCellComponent,
    AppRevenueCellComponent,
    AppRevenueHeaderCellComponent,
    AppWholesaleHeaderCellComponent,
    AppSelectorCustomComponentDirective,
  ],
  exports: [SalesOrderLineItemSelectorComponent],
  providers: [ItemSelectorAdapterService],
})
export class SalesOrderLineItemSelectorModule {}
